export default __webpack_public_path__ + "static/media/download-jianxi-csv.d90db7ad.svg";